/**
 * @param name    Cookie name
 * @param value   Cookie value (will be URI-encoded)
 * @param days    Lifetime in days (default 7). Pass 0 for a session cookie.
 */
export const setCookie = (
  name: string,
  value: string,
  days: number = 7,
): void => {
  let expires = "";
  if (days > 0) {
    const date = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }

  // Secure flag only when served over HTTPS (prevents accidental stripping in dev)
  const secure = window.location.protocol === "https:" ? "; Secure" : "";

  document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/; SameSite=Strict${secure}`;
};

/**
 * Read a cookie value by name, or null if not set.
 */
export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${encodeURIComponent(name)}=([^;]*)`),
  );
  return match ? decodeURIComponent(match[1]) : null;
};

/**
 * Delete a cookie by name.
 */
export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict`;
};
